export const ZENDESK_KEY = process.env.GATSBY_ZENDESK_KEY

export const ZendeskStatus = {
  Initial: "initial",
  Loading: "loading",
  Ready: "ready",
}
